module.exports = __webpack_public_path__ + "img/notifications-item.c2fcf7e0.svg";